export default [
  'SALECOMP1',
  'SALECOMP2',
  'SALECOMP3',
  'LISTCOMP1',
  'LISTCOMP2',
  'LISTCOMP3',
];
